export default {"src":"/login-app/[GIT_HASH]/_next/static/media/drag_handle.e6d8c525.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};